<template>
    <span :class="['label', `label-${labelClass}`]">{{ status.name }}</span>
</template>

<script>
    export default {
        props: ['status'],

        computed: {
            labelClass() {
                if (this.status.name === 'Approved') {
                    return 'success';
                }

                return 'warning';
            }
        }
    }
</script>

<style scoped>

</style>
